import{h as o,i as r}from"./chunk-CJSGIOWP.mjs";var m=new o({locale:r});export{m as a};
